export default __webpack_public_path__ + "static/cr-select-contacts-gif-b84ec88f122bc0c08573627fbab90c74.mp4";